import { forwardRef, useMemo } from 'react';

import {
  TailwindSelect as Select,
  TailwindSelectContent as SelectContent,
  TailwindSelectGroup as SelectGroup,
  TailwindSelectItem as SelectItem,
  TailwindSelectTrigger as SelectTrigger,
  TailwindSelectValue as SelectValue,
  Skeleton,
} from '../../tailwind';

import { getCurrencyIcon } from './CurrencySelect.helpers';

type CurrencySelectTypes = {
  onChange: (value: string) => void;
  value?: string;
  defaultValue?: string;
  disabled?: boolean;
  options: string[];
  loading: boolean;
};

const CurrencySelect = forwardRef<HTMLButtonElement, CurrencySelectTypes>(
  ({ onChange, value, disabled, options, loading, defaultValue }, ref) => {
    if (loading) {
      return <Skeleton className="h-12 w-[160px]" />;
    }

    return (
      <Select
        onValueChange={onChange}
        value={value}
        defaultValue={defaultValue ?? options?.[0]}
      >
        <SelectTrigger disabled={disabled} className="h-12 w-[160px]" ref={ref}>
          <SelectValue placeholder="Select currency" />
        </SelectTrigger>
        <SelectContent>
          <SelectGroup>
            {options.map((option) => (
              <CurrencyOption key={option} option={option} />
            ))}
          </SelectGroup>
        </SelectContent>
      </Select>
    );
  },
);

export default CurrencySelect;

const CurrencyOption = ({ option }: { option: string }) => {
  const icon = useMemo(() => getCurrencyIcon(option), [option]);
  return (
    <SelectItem value={option}>
      <div className="w-full flex items-center gap-2">
        {icon && <img src={icon} alt="country icon" />}
        {option}
      </div>
    </SelectItem>
  );
};
